
import { request, ua } from "@weapp/utils";
import { isProductEnv, isProOrBetaEnv } from "../utils";
// 本地加端口号测试使用
/**
 */
export const setNav = (data: any) => {

  return request({
    url: `/api/bcw/base/configuration/saveConfig`,
    method: "post",
    data: {
      'config': data
    }
  });
};
export const saveUserConfig = (data: any) => {

  return request({
    url: `/api/bcw/base/configuration/saveConfig`,
    method: "post",
    data: {
      'config': data
    }
  });
};
/**
 * 新用户语言设置
 */
export const updateUserlang = (lang: string) => {
  return request({
    url: `/api/bs/i18n/userlanguagemanage/updateUserlang?langtype=${lang}`,
    method: "get",
  });
};

/**
 * 更新用户缓存
 */
export const refreshEmployee = (empId: any, tenantKey: any) => {
  return request({
    url: `/papi/app/baseserver/refreshEmployee?empId=${empId}&tenantKey=${tenantKey}`,
    method: "get",
  });
};

/**
 * 导航所有模块菜单
 */
export const getAllModuleMenus = () => {
  return request({
    url: `/api/cusapp/app/allModuleMenus?terminalType=PC`,
    method: "get",
  });
};
/**
 * 获取导航与所有模块混合菜单
 */
export const getAllModuleMixedMenus = () => {
  return request({
    url: `/api/cusapp/app/hybridModuleMenus?terminalType=PC&menuType=0`,
    method: "get",
  });
};
/**
 * 获取导航与所有模块混合菜单
 */
//  export const getAllModuleMenus = () => {
//   return request({
//     url: `/api/cusapp/app/allModuleMenus?terminalType=PC`,
//     method: "get",
//   });
// };
/**
 * 文档详情展示判断
 */
export const getPopupDocumentIds = () => {
  return request({
    url: `/api/doc/portal/getPopupDocumentIds`,
    method: "get",
  });
};
/**
 * 登录时长
 */
export const loginTimeCheck = () => {
  if (isProductEnv()) {
    return request({
      url: `/papi/basicschedule/orgPortrait/update?employeeId=${window.TEAMS?.currentUser?.employeeId}&eteamsId=${window.ETEAMSID}`,
      method: "get",
    });
  } else {

    //同一个浏览器不同窗口减少轮询次数
    let lastPostTime = window.localStorage.getItem(`WEAPP_LAYOUT_ORG_PORTRAIT_TIME_${window.ETEAMSID}`) || 0;
    let now = new Date().getTime();
    const time = 5 * 60 * 1000 - 10;
    if (now - Number(lastPostTime) < time) {
      return;
    }
    window.localStorage.setItem(`WEAPP_LAYOUT_ORG_PORTRAIT_TIME_${window.ETEAMSID}`, String(now))

    return request({
      url: `/papi/basicschedule/orgPortrait/update`,
      method: "post",
      data: {
        employeeId: window.TEAMS?.currentUser?.employeeId,
        eteamsId: window.ETEAMSID
      }
    });
  }
};

/**
 * 获取左侧菜单
 */
export const queryLeftMenus = (module: string, userId: string) => {
  return request({
    url: `/api/${module}/leftMenu/queryLeftMenus`,
    method: "get",
    params: {
      userId: userId,
      ...ua
    }
  });
};
/**
 * 初始化左侧菜单
 */
export const initLeftMenus = (module: string) => {
  let url = `/api/${module}/leftMenu/initLeftMenus`;
  if (module === 'workflow/list') {
    url = `${url}?browser=${ua.browser}`;
  }
  return request({
    url: url,
    method: "get"
  });
};
/**
 * 保存左侧菜单
 */
export const saveLeftMenus = (module: string, data: any) => {
  let url = `/api/${module}/leftMenu/saveLeftMenus`;
  if (module === 'workflow/list') {
    url = `${url}?browser=${ua.browser}`;
  }
  return request({
    url: url,
    method: "post",
    data: data
  });
};
/**
 * 登录次数
 */
export const addLoginCount = () => {
  return request({
    url: `/api/baseserver/layout/addLoginCount`,
    method: "post"
  });
};

/**
 * 检验是否绑定手机号
 */
export const checkUserMobileBind = () => {
  return request({
    url: `/api/basicserver/invite/checkUserMobileBind`,
    method: "GET"
  });
};

// countab-事项统计数据
export const getCountTabValues = () => {
  return request({
    url: `/api/my/common/renderCount`,
    method: "get",
  });
};

// 获取企业微信终端下载地址
export const loadClientDownloadUrl = () => {
  return request({
    url: `/api/em/base/basicClientDownload`,
    method: "get",
  });
};
// 获取数据上报触发条件
export const getDataReport = () => {
  return request({
    url: `/api/formdatareport/incollect/checkCurrentUserMandatoryReport`,
    method: "POST",
  });
};

//profile侧边栏是否展示安全设置菜单权限
export const securityAllowSecondCheck = () => {
  return request({
    url: `/api/bs/datasecurity/encryptusersetting/allowSecondCheck`,
    method: "get",
  });
}

// 获取下属人员等信息
export const queryOtherUserInfo = (id: string) => {
  return request({
    url: `/api/hrm/profile/getUserProfile`,
    method: "get",
    params: {
      id,
    }
  });
};

//获取他人空间查看权限(是否下属或者关注对象)
export const isFollowAndSub = (id: string) => {
  return request({
    url: `/api/hrm/common/isFollowAndSub`,
    method: "post",
    data: {
      id,
    }
  });
};

//获取插件列表
export const getPcPluginList = () => {
  return request({
    url: `/api/basicserver/topicPlugin/qryPluginListOfEmp`,
    method: "get"
  });
};

//权限
export const loadPermissions = (menuCode: string) => {
  return request({
    url: `/api/basicserver/menu/check-permission`,
    method: "post",
    data: { "menuCode": menuCode }
  });
}


//根据user_id和tenant_key查询外部联系人信息
export const queryExternalEmployees = () => {
  return request({
    url: '/api/basicserver/external/queryExternalEmployees',
    method: "get",
  });
};

// 用于应用管理默认设置二期改造数据处理接口没有返回值-改造请沟通
export const transAppManageConfigs = () => {
  return request({
    url: '/api/basicserver/app/manage/transAppManageConfigs',
    method: "get",
  });
};

// 用于应用管理默认设置二期改造数据处理接口没有返回值-改造请沟通
export const transEmpMenusDisplay = () => {
  return request({
    url: '/api/basicserver/app/manage/transEmpMenusDisplay',
    method: "get",
  });
};


// 获取移动端底部导航数据
export const getNavMenuList = () => {
  return request({
    url: '/api/app/em/base/getNavMenuList',
    method: 'get',
    params: {
      devType: 1,
    }
  })
}

// 获取license到期提醒弹框
export const queryLicenseDiaRemind = () => {
  return request({
    url: `/api/basicserver/queryDialogRemindInfos`,
    method: "GET",
  });
}